import { getPaginationFromMeta } from '../utils/commonFunctions';

export const GET_PRIZE_PENDING = 'GET_PRIZE_PENDING';
export const GET_PRIZE_FULFILLED = 'GET_PRIZE_FULFILLED';
export const GET_PRIZE_REJECTED = 'GET_PRIZE_REJECTED';
export const ADD_PRIZE_PENDING = 'ADD_PRIZE_PENDING';
export const ADD_PRIZE_FULFILLED = 'ADD_PRIZE_FULFILLED';
export const ADD_PRIZE_REJECTED = 'ADD_PRIZE_REJECTED';
export const UPDATE_PRIZE_PENDING = 'UPDATE_PRIZE_PENDING';
export const UPDATE_PRIZE_FULFILLED = 'UPDATE_PRIZE_FULFILLED';
export const UPDATE_PRIZE_REJECTED = 'UPDATE_PRIZE_REJECTED';
export const GET_PRIZES_PENDING = 'GET_PRIZES_PENDING';
export const GET_PRIZES_FULFILLED = 'GET_PRIZES_FULFILLED';
export const GET_PRIZES_REJECTED = 'GET_PRIZES_REJECTED';
export const DELETE_PRIZE_PENDING = 'DELETE_PRIZE_PENDING';
export const DELETE_PRIZE_REJECTED = 'DELETE_PRIZE_REJECTED';
export const DELETE_PRIZE_FULFILLED = 'DELETE_PRIZE_FULFILLED';
export const GET_PRIZE_META_FULFILLED = 'GET_PRIZE_META_FULFILLED';
export const GET_PRIZE_META_PENDING = 'GET_PRIZE_META_PENDING';
export const GET_PRIZE_META_REJECTED = 'GET_PRIZE_META_REJECTED';
export const GET_PRIZE_OUTLET_INCENTIVES_FULFILLED = 'GET_PRIZE_OUTLET_INCENTIVES_FULFILLED';
export const GET_PRIZE_OUTLET_INCENTIVES_PENDING = 'GET_PRIZE_OUTLET_INCENTIVES_PENDING';
export const GET_PRIZE_OUTLET_INCENTIVES_REJECTED = 'GET_PRIZE_OUTLET_INCENTIVES_REJECTED';

export default function prizesReducer(
  state = {
    prizes: [],
    prize: {},
    meta: [],
    outlet_incentives: [],
    fetching: false,
    fetched: false,
    errors: {}
  },
  action
) {
  switch (action.type) {
    case GET_PRIZE_PENDING: {
      return { ...state, fetching: true, fetched: false };
    }
    case GET_PRIZE_FULFILLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        prize: action.payload.data
      };
    }
    case GET_PRIZE_REJECTED: {
      return {
        ...state,
        fetching: false,
        fetched: false
      };
    }
    case ADD_PRIZE_PENDING:
    case ADD_PRIZE_FULFILLED: {
      return {
        ...state,
        prize: {}
      };
    }
    case ADD_PRIZE_REJECTED: {
      return {
        ...state,
        errors: action.payload.errors
      };
    }
    case UPDATE_PRIZE_PENDING:
    case UPDATE_PRIZE_FULFILLED:
    case UPDATE_PRIZE_REJECTED:
    case DELETE_PRIZE_PENDING:
    case DELETE_PRIZE_FULFILLED:
    case DELETE_PRIZE_REJECTED:
    case GET_PRIZES_PENDING: {
      return { ...state, fetching: true, fetched: false };
    }
    case GET_PRIZES_FULFILLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        prizes: action.payload.data,
        paging: getPaginationFromMeta(
          state.paging,
          state.paging,
          action.payload.links
        )
      };
    }
    case GET_PRIZES_REJECTED: {
      return {
        ...state,
        fetching: false,
        fetched: false
      };
    }
    case GET_PRIZE_META_PENDING: {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case GET_PRIZE_META_FULFILLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        meta: action.payload
      };
    }
    case GET_PRIZE_META_REJECTED: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload.errors
      };
    }
    case GET_PRIZE_OUTLET_INCENTIVES_PENDING: {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case GET_PRIZE_OUTLET_INCENTIVES_FULFILLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        outlet_incentives: action.payload.data
      };
    }
    case GET_PRIZE_OUTLET_INCENTIVES_REJECTED: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload.errors
      };
    }
    default:
      return { ...state };
  }
}



// WEBPACK FOOTER //
// ./src/reducers/prizesReducer.js